import React, {useEffect, useMemo, useState} from "react";
import styles from './index.module.scss'
import { Button, message, Modal, Radio, Progress } from 'antd'
import { useIntl } from 'react-intl'
import html2canvas from 'html2canvas'
import { PDFDocument } from 'pdf-lib'
import hmLogo from '../../assets/img/hm_logo.png'
import bstLogo from '../../assets/img/bst.png'


let jsPDF = (window as any).jspdf.jsPDF
const Pdfcon: React.FC<any> = (props) => {
  const intl = useIntl()
  const { list, setOpen, colSelect, title, inlogo, dph, partnameData, partlangkey, shownum } = props

  const [loading, setLoading] = useState<boolean>(false)

  // const [progress, setProgress] = useState(0)

  // const [shownum, setShownum] = useState<number>(2)
  let logo = inlogo
  let origin = window.location.origin
  if(origin.includes("webtest.maiqipei.com") || origin.includes("gzhmqy.maiqipei.com") || origin.includes("gzhmqy.com") || origin.includes("300")) {
    logo = hmLogo
  }
  if(origin.includes("bmtsr.maiqipei.com") || origin.includes("bmtsr.xiaomaiqipei.com")) {
    logo = bstLogo
  }
  

  const classList: any = useMemo(() => {
    let _result: any = {}
    let result: any = []
    list.forEach((item: any) => {
      if(_result[item.main_group]) {
        _result[item.main_group].push(item)
      }else  {
        _result[item.main_group] = [item]
      }
    })
    Object.keys(_result).forEach((key) => {
      let extraLen = 4 - (_result[key].length % 4)
      _result[key] = [..._result[key], ...Array.from({ length: extraLen !== 4 ? extraLen: 0 }, () => ({main_group: key}))]
      result = [...result, ..._result[key]]
    })
    return result
  },[list])

  const downloadFile = (url: any) => {
    let a: any = document.createElement("a")
    a.setAttribute("id", url)
    a.setAttribute("download", title ? title.split(">").slice(0,3).join("-") : '')
    a.href = url
    a.click()
    a.remove()
    message.success(intl.formatMessage({ id: '导出成功' }))
  }
  const mergePDFsToBase64 = async (dataList: any) => {
    const mergedPdf = await PDFDocument.create()
    for(let pdfData of dataList) {
      const pdf: any = await PDFDocument.load(pdfData)
      const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices())
      copiedPages.forEach((page: any) => {
        mergedPdf.addPage(page)
      })
    }
    const mergedPdfBytes = await mergedPdf.save();
    const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
    const mergedpdfBase64 = URL.createObjectURL(blob);
    return mergedpdfBase64
  }


  async function htc(demo: any) {
    return new Promise((rev, rej) => {
      html2canvas(demo, {
        allowTaint: true, //允许跨域
        height: demo?.scrollHeight, //
        width: 1000, //为了使横向滚动条的内容全部展示，这里必须指定
    //     background: "#FFFFFF", //如果指定的div没有设置背景色会默认成黑色
        // dpi: 300,
        scale: 1.2,
        backgroundColor: '#FFFFFF',
        useCORS: true, //允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
      }).then((canvas) => {
        let pdf = new jsPDF('p', 'mm', 'a4'); //A4纸，纵向
        let ctx: any = canvas.getContext('2d'),
          a4w = 190,
          a4h = 277, //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
          imgHeight = Math.floor(a4h * canvas.width / a4w), //按A4显示比例换算一页图像的像素高度
          renderedHeight = 0;
    
    
    

    
        while (renderedHeight < canvas.height) {
          let page: any = document.createElement("canvas");
          page.width = canvas.width;
          // console.log(imgHeight, canvas.height, renderedHeight, canvas.width)
          page.height = Math.min(imgHeight, canvas.height - renderedHeight); //可能内容不足一页
          //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
          page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(
            imgHeight, canvas.height - renderedHeight)), 0, 0);
          pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 10, 10, a4w, 
            Math.min(a4h, a4w * page.height / page.width)
          ); //添加图像到页面，保留10mm边距
          renderedHeight += imgHeight;
          if (renderedHeight < canvas.height) pdf.addPage(); //如果后面还有内容，添加一个空页
        }
        let pdfData = pdf.output('dataurlstring')
        rev(pdfData)
      })
    })
    
  }

  async function newgeneratePDF(id?: any) {


    setLoading(true)
    //下载pdf方法
    let container: any = document.getElementById(id);
    // console.log(container.children[1].children)
    // console.log(container.style)

    let children: any = container.children

    
    
    const chunkSize = shownum === 2 ? 20 : 100; // 每批渲染5个子元素
    const canvasList = [];

    // 分批处理子元素
    for (let i = 0; i < children.length; i += chunkSize) {
      // 创建临时容器，仅包含当前批次的元素
      const tempContainer = document.createElement('div');
      tempContainer.setAttribute("class", styles['products'])
      if(shownum === 2) {
        let img = document.createElement("img")
        img.src = logo
        img.style.height = '60px'
        img.setAttribute("class", styles['page-logo-1'])
        tempContainer.appendChild(img)
        tempContainer.style.paddingTop = '170px'
        let div = document.createElement("div")
        div.innerText = title ? title.split(">").join(" ") : ''
        div.setAttribute("class", styles['sp'])
        tempContainer.appendChild(div)
      }else {
        if(i === 0) {
          let img = document.createElement("img")
          img.src = logo
          img.style.height = '60px'
          img.setAttribute("class", styles['page-logo'])
          tempContainer.appendChild(img)
          tempContainer.style.paddingTop = '170px'
          let div = document.createElement("div")
          div.innerText = title ? title.split(">").join(" ") : ''
          div.setAttribute("class", styles['sp'])
          tempContainer.appendChild(div)
        }
      }
      for (let j = i; j < i + chunkSize && j < children.length; j++) {
        tempContainer.appendChild(children[j].cloneNode(true));
      }
      document.body.appendChild(tempContainer); // 临时添加到页面

      let canvasUrl = await htc(tempContainer)
      canvasList.push(canvasUrl);
      document.body.removeChild(tempContainer); // 移除临时容器
    }
    let url = await mergePDFsToBase64(canvasList)
    setLoading(false)
    downloadFile(url)
    setTimeout(() => {
      URL.revokeObjectURL(url)
    })
    return false
    
  }

  function generatePDF(id: any) {
    setLoading(true)
    //下载pdf方法
    let demo: any = document.getElementById(id);

    demo.style.overflow = 'visible';
    html2canvas(demo, {
      allowTaint: true, //允许跨域
      height: document.getElementById(id)?.scrollHeight, //
      width: document.getElementById(id)?.scrollWidth, //为了使横向滚动条的内容全部展示，这里必须指定
  //     background: "#FFFFFF", //如果指定的div没有设置背景色会默认成黑色
      // dpi: 300,
      scale: 1,
      backgroundColor: '#FFFFFF',
      useCORS: true, //允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
    }).then((canvas) => {
      console.log(canvas, 'canvas')
      let pdf = new jsPDF('p', 'mm', 'a4'); //A4纸，纵向
      let ctx: any = canvas.getContext('2d'),
        a4w = 190,
        a4h = 277, //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
        imgHeight = Math.floor(a4h * canvas.width / a4w), //按A4显示比例换算一页图像的像素高度
        renderedHeight = 0;
  
  
      while (renderedHeight < canvas.height) {
        let page: any = document.createElement("canvas");
        page.width = canvas.width;
        page.height = Math.min(imgHeight, canvas.height - renderedHeight); //可能内容不足一页
        //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
        page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(
          imgHeight, canvas.height - renderedHeight)), 0, 0);
        pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 10, 10, a4w, Math.min(a4h, a4w * page.height /
          page.width)); //添加图像到页面，保留10mm边距
        renderedHeight += imgHeight;
        if (renderedHeight < canvas.height) pdf.addPage(); //如果后面还有内容，添加一个空页
      }
      pdf.save(title + '.pdf');
    }).finally(() => {
    setLoading(false)
  })
    demo.style.overflow = 'auto';
  }

  let lang = window.localStorage.getItem('lang') === 'zh' ? 'cn' : window.localStorage.getItem('lang')
  return (
    <Modal
      title={
        <div className="flex-b-c">
          <div className="flex-s-c">
            <label className="mr20">{intl.formatMessage({ id: '预览' })}</label>
            {/* <Radio.Group
              options={
                [
                  {
                    label: intl.formatMessage({ id: '样式1' }),
                    value: 2
                  },
                  {
                    label: intl.formatMessage({ id: '样式2' }),
                    value: 1
                  },
                ]
              }
              value={shownum}
              onChange={(e) => setShownum(e.target.value)}
            >
            </Radio.Group> */}
          </div>
          <div className="flex-s-c">
            {/* {
              progress ? (
                <Progress type="circle" percent={progress} size={36} />
              ): null
            } */}
            <Button type="primary" className="mr30 ml10" loading={loading} onClick={() => newgeneratePDF('pdfContent')}>{intl.formatMessage({ id: '导出' })}</Button>
          </div>
        </div>
      }
      open={true}
      onCancel={() => setOpen(false)}
      destroyOnClose
      footer={null}
      width={1100}
      
    >
      <div className={styles['pdfcon']} id="pdfcon" >
        {
          shownum === 2 ? (
            <>
              <div className={styles['page-logo-1']} style={{ left: 20 }}>
                <img style={{ height: 60 }} src={logo} />
              </div>
              <div  style={{ marginTop: 100 }}>
                <div className="flex-s-c">
                  <div className="plr15 ptb5" style={{ background: '#1890ff', color: '#fff', borderRadius: 8, fontSize: 18, fontWeight: 500 }}>
                    {title ? title.split(">").join(" ") : ''}
                  </div>
                </div>
                <div id="pdfContent" className={styles['products']} style={{ marginTop: 20, width: 1000 }}>
                  {
                    classList.map((item: any, index: number) => {
                      return (
                        <div className={styles["product-card-1"]} key={index}>
                          <div className="flex plr10" style={{ justifyContent: 'space-between' }}>
                            <div>
                              {
                                item.part_name ? (
                                  <div className="p-color">{item.main_group || ""}</div>
                                ): null
                              }
                              <div>{item.part_name ? dph : ''} {colSelect.includes("part_name") && item.part_name ? item.part_name : ''}</div>
                              {
                                partlangkey !== lang ? (
                                  <div>{colSelect.includes("part_name") && partnameData[item.part_name] && item.part_name ? partnameData[item.part_name][partlangkey] : ''}</div>
                                ): null
                              }
                              <div>{colSelect.includes("code") && item.code ? item.code : ''}</div>
                            </div>
                            <img  className={styles['logo-1'] + ' ml10'} src={logo} />
                          </div>
                          <div className="flex-c-c">
                            {
                              colSelect.includes("img") && item.img ? (
                                <img className={styles['img-1']} src={item.img} />
                              ): null
                            }
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
              
            </>
          ): (
            <>
              <div className={styles['page-logo']}>
                <img style={{ height: 60 }} src={logo} />
              </div>
              <div className="flex-s-c" style={{ paddingTop: 50 }}>
                <div className="plr15 ptb5" style={{ background: '#1890ff', color: '#fff', borderRadius: 8, fontSize: 18, fontWeight: 500 }}>
                  {title ? title.split(">").join(" ") : ''}
                </div>
              </div>
              <div className={styles['products']} id="pdfContent">
                {
                  list.map((item: any, index: number) => {
                    return (
                      <div className={styles["product-card"]} key={index}>
                        {
                          colSelect.includes("part_name") ? (
                            <h3>{item.part_name}</h3>
                          ): null
                        }
                        <div style={{ borderTop: '2px solid #ff7f00' }} className="flex-b-c">
                          <div >
                            {
                              item.part_name && item.main_group ? (
                                <div className={styles["product-props"]}>
                                  <span className={styles["prop-label"]}>{intl.formatMessage({ id: '分类' })}:</span>
                                  <span className={styles["prop-value"] + ' p-color'} style={{ color: '#096BED' }}>{item.main_group}</span>
                                </div>
                              ): null
                            }
                            {
                              colSelect.includes("quality_oe") ? (
                                <div className={styles["product-props"]}>
                                  <span className={styles["prop-label"]}>{intl.formatMessage({ id: '原厂OE' })}:</span>
                                  <span className={styles["prop-value"]}>{item.quality_oe}</span>
                                </div>
                              ): null
                            }
                            {
                              colSelect.includes("code") ? (
                                <div className={styles["product-props"]}>
                                  <span className={styles["prop-label"]}>{intl.formatMessage({ id: '产品编码' })}:</span>
                                  <span className={styles["prop-value"]}>{item.code}</span>
                                </div>
                              ): null
                            }
                            {
                              colSelect.includes("warranty") ? (
                                <div className={styles["product-props"]}>
                                  <span className={styles["prop-label"]}>{intl.formatMessage({ id: '质保时间' })}:</span>
                                  <span className={styles["prop-value"]}>{item.warranty}</span>
                                </div>
                              ): null
                            }
                            {
                              colSelect.includes("quality_name") && colSelect.includes("quality_price") ? (
                                <div className={styles["product-props"]}>
                                  <span className={styles["prop-label"]}>{intl.formatMessage({ id: '销售价格' })}:</span>
                                  <span className={styles["prop-value"]}>{item.quality_name}: ¥{item.quality_price}</span>
                                </div>
                              ): null
                            }
                            {
                              colSelect.includes("params") ? (
                                <div className={styles["product-props"]}>
                                  <span className={styles["prop-label"]}>{intl.formatMessage({ id: '产品参数' })}:</span>
                                  <span className={styles["prop-value"]}>{item.params}</span>
                                </div>
                              ): null
                            }
                          </div>
                          {
                            colSelect.includes("img") ? (
                              <div className={styles["product-img"]}>
                                <img src={item.img}  />
                              </div>
                            ): null
                          }
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </>
          )
        }

        
      </div>
    </Modal>
    
  )
}

export default Pdfcon